<div *ngIf="value && value.length > 0; else noColumns" class="column-select-container">
  <div *ngFor="let column of value; index as columnIndex" class="column">
    <ion-select
      #columnSelect
      interface="popover"
      [attr.data-index]="columnIndex"
      (ionChange)="columnChanged($event)"
      [(ngModel)]="selectedValues[columnIndex]"
    >
      <ion-select-option *ngIf="allowEmpty" value="">&mdash;</ion-select-option>
      <ion-select-option *ngFor="let c of columns" [value]="c.id">{{ c.name }}</ion-select-option>
    </ion-select>
  </div>
</div>

<ng-template #noColumns>
  <div class="no-columns-message">
    <ion-text color="medium">Žádné sloupce nejsou k dispozici</ion-text>
  </div>
</ng-template>
